// src/constants/index.js

export const API_BASE_URL = process.env.REACT_APP_API_URL || "http://127.0.0.1:8000";

export const ROUTES = {
  HOME: "/home",
  LOGIN: "/login",
  REGISTER: "/register",
  DASHBOARD: "/dashboard",
  MIS_RECLAMOS: "/mis-reclamos",
  CREAR_RECLAMO: "/crear-reclamo",
  PERFIL: "/perfil",
  GESTIONAR_USUARIOS: "/gestionar-usuarios",
  GESTIONAR_RECLAMOS: "/gestionar-reclamos",
  WELCOME: "/",
  RECLAMO_DETALLE: "/reclamo/:id"
};

export const RECLAMO_ESTADOS = {
  PENDIENTE: "pendiente",
  EN_PROGRESO: "en_progreso",
  RESUELTO: "resuelto"
};

export const RECLAMO_PRIORIDADES = {
  BAJA: "baja",
  MEDIA: "media",
  ALTA: "alta"
};

export const ESTADOS_CONFIG = [
  { value: RECLAMO_ESTADOS.PENDIENTE, label: "Pendiente", color: "#fbbf24" },
  { value: RECLAMO_ESTADOS.EN_PROGRESO, label: "En Progreso", color: "#3b82f6" },
  { value: RECLAMO_ESTADOS.RESUELTO, label: "Resuelto", color: "#10b981" }
];

export const PRIORIDADES_CONFIG = [
  { value: RECLAMO_PRIORIDADES.BAJA, label: "Baja", color: "#6b7280" },
  { value: RECLAMO_PRIORIDADES.MEDIA, label: "Media", color: "#f59e0b" },
  { value: RECLAMO_PRIORIDADES.ALTA, label: "Alta", color: "#ef4444" }
];

export const CATEGORIAS = {
  ALUMBRADO: "alumbrado",
  BACHES: "baches",
  RESIDUOS: "residuos",
  SEGURIDAD: "seguridad",
  OTRO: "otro"
};

export const CATEGORIAS_CONFIG = [
  { value: CATEGORIAS.ALUMBRADO, label: "Alumbrado", icon: "💡" },
  { value: CATEGORIAS.BACHES, label: "Baches", icon: "🕳️" },
  { value: CATEGORIAS.RESIDUOS, label: "Residuos", icon: "🗑️" },
  { value: CATEGORIAS.OTRO, label: "Otro", icon: "📌" }
];

export const ROLES = {
  CIUDADANO: "ciudadano",
  ADMIN: "admin",
  AGENTE_MUNICIPAL: "agente_municipal"
};

export const ROLES_CONFIG = [
  { value: ROLES.CIUDADANO, label: "Ciudadano" },
  { value: ROLES.ADMIN, label: "Administrador" },
  { value: ROLES.AGENTE_MUNICIPAL, label: "Agente Municipal" }
];

export const LA_PLATA_CENTER = [-34.921, -57.954];
export const DEFAULT_ZOOM = 13;

export const ERROR_MESSAGES = {
  AUTH_FAILED: "Error de autenticación. Por favor, inicia sesión nuevamente.",
  SESSION_EXPIRED: "Tu sesión ha expirado. Por favor, inicia sesión nuevamente.",
  NETWORK_ERROR: "Error de conexión. Por favor, verifica tu internet.",
  UNAUTHORIZED: "No tienes permisos para realizar esta acción.",
  GENERIC: "Ocurrió un error. Por favor, intenta nuevamente."
};

export const SUCCESS_MESSAGES = {
  RECLAMO_CREATED: "Reclamo creado exitosamente",
  RECLAMO_UPDATED: "Reclamo actualizado exitosamente",
  RECLAMO_DELETED: "Reclamo eliminado exitosamente",
  USER_UPDATED: "Usuario actualizado exitosamente",
  LOGIN_SUCCESS: "Inicio de sesión exitoso",
  REGISTER_SUCCESS: "Registro exitoso"
};